import React from 'react'
import HomeBanner from './HomeBanner'
import HomeClientLogo from './HomeClientLogo'
import HomeTab from './HomeTab'
import HomeDocument from './HomeDocument'
import HomeCounter from './HomeCounter'
import HomeResource from './HomeResource'
import HomeTestimonial from './HomeTestimonial'
import HomeBlog from './HomeBlog'
import HomeCta from './HomeCta'

const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]

const countData = [
  {
    number: "24",
    suffix: "K+",
    desc: "<b>Businesses Served</b>: Trusted by organizations across diverse industries"
  },
  {
    number: "99",
    suffix: "%",
    desc: "<b>Retrieval Accuracy</b>: Ensure fast, precise, reliable access to documents"
  },
  {
    number: "940",
    suffix: "M+",
    desc: "<b>Documents Digitized</b>: Converted into structured, indexed, fully searchable digital formats"
  },
  {
    number: "10",
    suffix: "K+",
    desc: "<b>Manual Hours Saved:</b>: Streamlined Workflows, Reduced Manual Tasks & Improved Productivity"
  },
]

const testimonialData = {
    title: "Trusted by industry leaders",
    slides: [
      {
        title:"“Driving Operational Accuracy and Efficiency”",
        desc:"Dox and Box have helped us streamline document handling and operational coordination in a much more efficient way. The platform is practical, easy to manage, supports fast-moving business environments where accuracy and accessibility are critical. Their structured approach has also helped improve collaboration and process transparency across teams.",
        image:"/assets/images/testimonial-user-1.webp",
        name: "Gaurav Attar",
        designation: "Senior Manager",
      },
      {
        title:"“Enabling Agile Business Operations Daily”",
        desc:"Dox and Box bring much-needed structure and efficiency to document management. The platform supports operational agility while ensuring teams can access critical information quickly and securely. It has also helped create smoother workflows and better visibility across operational functions.",
        image:"/assets/images/testimonial-user-2.webp",
        name: "Mihir Kevale",
        designation: "General Manager",
      },
      {
        title:"“Strengthening Finance and Compliance Processes”",
        desc:"Dox and Box have helped bring greater clarity and efficiency to document management processes. For finance and compliance-driven functions, having organized and easily accessible records makes a significant operational difference. The platform has also contributed to faster coordination and improved process consistency across teams.",
        image:"/assets/images/testimonial-user-3.webp",
        name: "Sushmita Satyamurty",
        designation: "Country Finance Specialist",
      },
      {
        title:"“Simplifying Critical Healthcare Documentation Workflows”",
        desc:"In healthcare operations, accurate documentation and timely accessibility are extremely important. Dox and Box have helped streamline processes and improve operational coordination simply and effectively. Their platform has also supported faster information access and improved day-to-day workflow efficiency.",
        image:"/assets/images/testimonial-user-4.webp",
        name: "Shantanu Patki",
        designation: "Purchase and Pharmacy Operations",
      },
      {
        title:"“ Improving Procurement Visibility and Coordination”",
        desc:"Efficient procurement operations depend heavily on organized documentation and process visibility. Dox and Box have helped simplify document management while improving coordination and operational efficiency across teams. The system has also enabled better tracking and faster access to important operational records.",
        image:"/assets/images/testimonial-user-5.webp",
        name: "Srinivas Mantri",
        designation: "Senior Procurement Manager, Beam Global Asia",
      },
      {
        title:"“Enhancing Compliance and Cost Visibility”",
        desc:"Dox and Box have helped improve document organization and operational visibility in a very efficient way. For compliance and cost-control functions, having structured and easily accessible records makes day-to-day processes significantly smoother. The platform has also strengthened coordination and improved overall process management efficiency.",
        image:"/assets/images/testimonial-user-6.webp",
        name: "Vivek Singh",
        designation: "Compliance | Budget & Cost Control",
      },
      {
        title:"“Streamlining Procurement Documentation and Decisions”",
        desc:"Dox and Box have brought greater efficiency and structure to documentation management processes. For procurement operations, having quick access to organized records significantly improves coordination and decision-making. The platform has also helped simplify workflows and enhance operational responsiveness across teams.",
        image:"/assets/images/testimonial-user-7.webp",
        name: "Manik Shah",
        designation: "Associate Director",
      },
      {
        title:"“Driving Structured Commercial Process Management”",
        desc:"Dox and Box have helped bring greater structure and visibility to documentation processes. In commercial and finance functions, organized and easily accessible information plays a critical role in improving operational efficiency. The platform has also supported smoother coordination and improved process clarity across departments.",
        image:"/assets/images/testimonial-user-8.webp",
        name: "Raghvendra Singh Sengar",
        designation: "Project Commercial and Finance Head",
      },
      
    ],
  };

export default function Home({initialData}) {
  return (
    <>
      <HomeBanner/>
      <HomeClientLogo/>
      <HomeTab tabData={tabData}/>
      <HomeDocument/>
      <HomeCounter countData={countData}/>
      <HomeResource/>
      <HomeTestimonial data = {testimonialData}/>
      <HomeBlog initialData={initialData?.blogs}/>
      <HomeCta/>
    </>
  )
}
